import { render, staticRenderFns } from "./ClassDropdown.vue?vue&type=template&id=4553f562&"
import script from "./ClassDropdown.vue?vue&type=script&lang=ts&"
export * from "./ClassDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ClassDropdown.vue?vue&type=style&index=0&id=4553f562&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports